import { render, staticRenderFns } from "./ShogaiLoginSpecialForms.vue?vue&type=template&id=5dc0b83e&scoped=true"
import script from "./ShogaiLoginSpecialForms.vue?vue&type=script&lang=js"
export * from "./ShogaiLoginSpecialForms.vue?vue&type=script&lang=js"
import style0 from "./ShogaiLoginSpecialForms.vue?vue&type=style&index=0&id=5dc0b83e&prod&lang=scss&scoped=true"
import style1 from "./ShogaiLoginSpecialForms.vue?vue&type=style&index=1&id=5dc0b83e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc0b83e",
  null
  
)

export default component.exports